export default "__VITE_ASSET__nwa2DvjW__"